import React from 'react';

import { useLingui } from '@lingui/react/macro';
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { colors } from '../../../../utils/theme';
import { useRotation } from '../RotationContext';

const useStyles = makeStyles(() => ({
  changesMadeIndicatorTop: {
    zIndex: 5,
    position: 'absolute',
    top: 15,
    right: 0,
  },
  changesMadeIndicatorBottom: {
    zIndex: 5,
    position: 'absolute',
    bottom: 60,
  },
}));

interface Props {
  image: any;
  isThumbnail: boolean;
}

const useGetChipStylesAndText = (input: {
  currentlyRotatingImages: {
    imageIds: string[];
    images: any[];
  };
  image: any;
  classes: any;
  isThumbnail: boolean;
  errorImageIds: string[];
}) => {
  const { t } = useLingui();
  const { classes, currentlyRotatingImages, image, isThumbnail } = input;
  const defaultChipStatusStyle = {
    height: 20,
    width: 60,
    fontSize: 10,
    padding: 0,
    margin: 0,
  };
  if (
    currentlyRotatingImages.imageIds.includes(image.objectId) &&
    isThumbnail
  ) {
    return {
      label: t`Rotated`,
      style: {
        borderRadius: 2,
        backgroundColor: colors.PRIMARY,
        color: 'white',
        ...defaultChipStatusStyle,
      },
      size: 'small',
      className: isThumbnail
        ? classes.changesMadeIndicatorTop
        : classes.changesMadeIndicatorBottom,
    };
  }

  if (input.errorImageIds.includes(image.objectId)) {
    return {
      label: isThumbnail
        ? t`Failed`
        : t`Image failed to load the updated analysis. Please rerun the AI.`,
      style: {
        borderRadius: 2,
        backgroundColor: colors.ORANGE,
        color: 'black',
        ...defaultChipStatusStyle,
        ...(isThumbnail ? {} : { width: 400 }),
      },
      size: isThumbnail ? 'small' : 'medium',
      className: isThumbnail
        ? classes.changesMadeIndicatorTop
        : classes.changesMadeIndicatorBottom,
    };
  }

  return null;
};

const ImageChipStatus: React.FC<Props> = ({ image, isThumbnail }) => {
  const { currentlyRotatingImages, errorImageIds, isConnectedToConnector } =
    useRotation();

  const classes = useStyles();

  const chipStylesAndText = useGetChipStylesAndText({
    // @ts-expect-error TS(2322): Type '{ imageIds: string[]; images: any[]; } | und... Remove this comment to see the full error message
    currentlyRotatingImages,
    image,
    classes,
    isThumbnail,
    errorImageIds,
  });

  if (!chipStylesAndText || isConnectedToConnector) {
    return <></>;
  }

  return (
    <div className={chipStylesAndText.className}>
      <Chip
        label={chipStylesAndText.label}
        size={chipStylesAndText.size as 'small' | 'medium'}
        style={chipStylesAndText.style}
      />
    </div>
  );
};

export default ImageChipStatus;
